module.exports = __webpack_public_path__ + "static/pro2.png";